import {
  normalizeBoolean,
  normalizePhoneBR,
  normalizeTime,
  parseDateFlexible,
  type AppointmentImportRecord,
} from "@bookdental/schemas";
import type { ParsedFile } from "./parseFile";

/** Paleta de 16 cores — espelha ASSORTED_PALETTE de agenda-colors.ts. */
const PALETTE = [
  "#14B8A6", "#06B6D4", "#10B981", "#F59E0B", "#EF4444", "#EC4899",
  "#3B82F6", "#14B8A6", "#F97316", "#84CC16", "#6366F1", "#A855F7",
  "#E11D48", "#0EA5E9", "#22C55E", "#EAB308",
];

function hashColorFromName(name: string): string {
  let h = 0;
  for (let i = 0; i < name.length; i++) {
    h = (h << 5) - h + name.charCodeAt(i);
    h |= 0;
  }
  return PALETTE[Math.abs(h) % PALETTE.length];
}

export function buildAppointmentRecords(
  parsed: ParsedFile,
  mappings: Record<string, string>,
): AppointmentImportRecord[] {
  const colToField: Array<[number, string]> = [];
  parsed.headers.forEach((h, idx) => {
    const field = mappings[h];
    if (field && field !== "ignore") colToField.push([idx, field]);
  });

  const out: AppointmentImportRecord[] = [];

  for (const row of parsed.rows) {
    const rec: Partial<AppointmentImportRecord> = {};

    for (const [colIdx, field] of colToField) {
      const raw = row[colIdx] ?? "";
      if (!raw) continue;

      switch (field) {
        case "date": {
          const d = parseDateFlexible(raw);
          if (d) rec.date = d.toISOString().slice(0, 10);
          break;
        }
        case "startTime": {
          const t = normalizeTime(raw);
          if (t) rec.startTime = t;
          break;
        }
        case "endTime": {
          const t = normalizeTime(raw);
          if (t) rec.endTime = t;
          break;
        }
        case "cancelled":
          rec.cancelled = normalizeBoolean(raw);
          break;
        case "patientPhone": {
          const p = normalizePhoneBR(raw);
          if (p) rec.patientPhone = p;
          break;
        }
        default:
          (rec as Record<string, unknown>)[field] = raw;
      }
    }

    if (!rec.patientName || !rec.date) continue;
    // Cor deterministica por nome do paciente — mesmo paciente sempre mesma cor
    rec.color = hashColorFromName(rec.patientName);
    out.push(rec as AppointmentImportRecord);
  }

  return out;
}
